export default {
  ctr: {
    name: 'CTR',
    fullName: 'Click-Through-Rate',
    formula: 'click / impression * 100%',
    desc: '点击通过率，是互联网广告常用的术语，指网络广告的点击到达率，即该广告的实际点击次数（严格的来说，可以是到达目标页面的数量）除以广告的展现量（Show content）。',
    compute: (click, impression) => Number((click / impression).toFixed(4))
  },
  cvr: {
    name: 'CVR',
    fullName: 'Conversion Rate',
    formula: 'install / click * 100%',
    desc: '用户点击广告到成为一个有效激活或者注册甚至付费用户的转化率。',
    compute: (click, install) => Number((install / click).toFixed(4))
  },
  ivr: {
    name: 'IVR',
    fullName: '',
    formula: 'install / impression * 100%',
    desc: '安装数 / 展示数',
    compute: (install, impression) => Number((install / impression).toFixed(4))
  },
  eCPM: {
    name: 'eCPM',
    fullName: 'effective Cost Per Mile',
    formula: 'revenue / impression',
    desc: '指的是每一千次展示可以获得的广告收入',
    compute: (revenue, impression) => Number((revenue / impression).toFixed(4))
  },
  gs_rate: {
    name: 'gs_rate',
    fullName: 'game start rate',
    formula: 'gs / gr',
    desc: '游戏开始率',
    compute: (gs, gr) => Number((gs / gr).toFixed(4))
  },
  rd_rate: {
    name: 'rd_rate',
    fullName: 'render rate',
    formula: 'ir / pv',
    desc: '渲染成功率',
    compute: (ir, pv) => Number((ir / pv).toFixed(4))
  },
  fc_rate: {
    name: 'fc_rate',
    fullName: 'first click rate',
    formula: 'fc / gs',
    desc: '试玩率',
    compute: (fc, gs) => Number((fc / gs).toFixed(4))
  },
  gr_rate: {
    name: 'gr_rate',
    fullName: 'game ready rate',
    formula: 'ge / gs',
    desc: '游戏完成率',
    compute: (ge, gs) => Number((ge / gs).toFixed(4))
  }
}